<template>
  <div class="page" ref="wrapper">
    <el-container>
      <div class="header-redio">
        <el-radio-group v-model="activeTable" @change="handleRadioChange">
          <el-radio border size="small" :label="0">大型号品类分布</el-radio>
          <el-radio border size="small" :label="1">大型号销售定位概览</el-radio>
          <el-radio border size="small" :label="2">大型号产品类别概览</el-radio>
        </el-radio-group>
        <div style="float: right">
          <!-- <el-button type="primary" size="small" @click="onExport"
            >导出</el-button
          > -->
          <el-button class="search-btn iconfont bg-dc-btn" style="top:0" @click="onExport">&#xe60f;&nbsp;导出</el-button>
        </div>
      </div>
      <el-header height="auto">
        <el-form
          :model="formData"
          :inline="true"
          size="mini"
          style="margin-top: 10px"
          label-width="75px"
        >
          <el-form-item label="时间选择:" v-if="activeTable == 0">
            <el-select
              v-model="formData.year"
              placeholder="请选择"
              class="yearSelect"
              @change="yearChange"
            >
              <el-option
                v-for="item in timeYear"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="activeTable == 0">
            <el-select
              v-model="formData.month"
              placeholder="请选择"
              class="yearSelect"
              @change="init"
            >
              <el-option
                v-for="item in timeMonth"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品类:" v-if="activeTable == 1 || activeTable == 2" class="category">
            <el-autocomplete
              class="form-input"
              v-model.trim="formData.category"
              :fetch-suggestions="querySkuList"
              @blur="categoryChange"
              @focus="onSkuCodeFocus(1)"
              
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="型号:" v-if="activeTable == 1 || activeTable == 2" class="category">
            <el-autocomplete
              class="form-input"
              v-model.trim="formData.bigModel"
              :fetch-suggestions="querySkuList"
              @blur="bigModelChange"
              @focus="onSkuCodeFocus(2)"
              
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="产品类别:">
            <el-select v-model="formData.productType" @change="init">
             <el-option label="全部" value='' v-show="activeTable == 2"></el-option>
             <el-option label="整体" :value="`${activeTable != 2 ? '' : '整体'}`"></el-option>
             <el-option
                v-for="item in productCategoryData.productType"
                :label="item.content"
                :key="item.content"
                :value="item.content"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="float: right">
            <el-button type="text" style="font-size: 14px" v-if="rihType" @click="detailed">显示明细</el-button>
            <el-button type="text" 
              style="font-size: 14px" 
              @click="configure" 
              v-permission="'ec-pc-new$reportCenter$productData$lifeCycleManagement$Basicconfiguration'"
              >基础配置</el-button
            >
          </div>
        </el-form>
      </el-header>
      <el-main ref="main">
        <div style="margin-bottom: 5px"></div>
        <el-table
          stripe
          border
          ref="table"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :cell-style="rowCompare"
          highlight-current-row
          :data="tableData"
          :height="tableHeight"
          :span-method="objectSpanMethod"
          v-if="tableHeight && tableReload"
          v-loading="loading"
        >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :min-width="item.width"
            show-overflow-tooltip
            v-for="item in sortedPropList"
            :key="item.prop"
            align="center"
          >
            <template slot="header" v-if="item.label == '品类' && activeTable == 0">
            <span>品类</span>
            <el-tooltip class="item" effect="dark" placement="top" style="position: relative; top: 1px;">
              <span class="el-icon-question"></span>
              <div slot="content">点击品类名称后显示各款式判断规则</div>
            </el-tooltip>
          </template>
            <template slot-scope="scope">
              <el-link :underline="false"  v-if="activeTable == 0 && item.prop == 'category'" @click="changeCategory(scope.row)">{{ scope.row.category }}</el-link>
              <span
                v-else-if="
                  item.prop == 'category' ||
                  item.prop == 'productType' ||
                  !rihType
                "
                >{{ scope.row[item.prop] }}</span
              >
              <span :class="`${scope.row.productType == '整体' ? 'categoryRed' : 'categoryCilck' }`"
                @click="viewSales(scope)"
                v-else
                >{{ scope.row[item.prop]}}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <v-dialog v-model="categoryDialogVisible" :config="{ showButton: false, width: '40%', title: categoryName +'销售等级计算规则' }">
      <div slot="content">
        <el-table
          border
          :data="categoryTableData"
          max-height="500px"
          v-if="categoryDialogVisible"
          v-loading="loading2"
          >
          <el-table-column label="产品类别" prop="productTypeName" align="center"></el-table-column>
          <el-table-column label="销售等级" prop="saleLocationName" align="center"></el-table-column>
          <el-table-column label="规则" prop="ruleDesc" align="center"></el-table-column>
        </el-table>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import importExportMxin from "../import&export.mixin";
import customProps from "../customProps.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from "moment";
export default {
  mixins: [importExportMxin, customProps, pagePathMixin],
  props: ['tableHeight'],
  components: {},
  data() {
    return {
      activeTable: 0,
      loading: false,
      loading2: false,
      formData: {
        year: moment().year(),
        month: moment().month()+1,
        category: "",
        productType: ''
      },
      exportData: {},
      tableData: [],
      year: "",
      columnJurisdiction: true,
      tableReload: true,
      optionData: [],
      inputData: [],
      productCategoryData: [],
      categoryDialogVisible: false,
      categoryName: '',
      categoryTableData: []
    };
  },
  computed: {
    timeYear() {
      let year = moment().year();
      let yearLength = year - 2021;
      let previousYear = year;
      let sumYear = [];
      for (let i = 0; i <= yearLength; i++) {
        sumYear.push({
          value: previousYear - i,
          lable: previousYear - i + "年",
        });
        sumYear.sort(function (a, b) {
          return b.lable - a.lable;
        });
      }
      return sumYear;
    },
    timeMonth() {
      var monthNum = [];
      let setMonth = moment().month()+1
      if(this.formData.year == moment().year()) {
        for (let index = 1; index <= setMonth; index++) {
           monthNum.push(index)
        }
      }else if(this.formData.year == 2021) {
        monthNum = [11, 12]
      }else {
        monthNum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      }
      let sumMonth = [];
      for (let i = 0; i < monthNum.length; i++) {
        sumMonth.push({
          value: monthNum[i],
          lable: monthNum[i] + "月",
        });
      }
      return sumMonth;
    },
    yearsMonth() {
      let timeYear = this.formData.year
      let timeMonth = this.formData.month
      let yearsMonth = ""
      if(timeMonth < 10) {
        yearsMonth = (timeYear + '') +( '0' + timeMonth)
      }else{
        yearsMonth = (timeYear + '') + timeMonth
      }
      return yearsMonth
    },
    rihType() {
      if (
        this.formData.year == moment().year() &&
        this.formData.month == moment().month() + 1 
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    categoryChange() {
      setTimeout(() => {
        this.getOptions()
        this.init()
      }, 200);
    },
    bigModelChange() {
      setTimeout(() => {
        this.getOptions()
        this.init()
      }, 200);
    },
    configure() {
      this.$router.push({
        path: "/newProduct/lifecycleConfiguration",
      });
    },
    detailed() {
      this.openSubPage({
        name: "LargeSizeDetails",
        params:{
          category: this.activeTable != 0 ? this.formData.category : "",
          bigModel: this.formData.bigModel,
          categoryType: this.formData.productType == '整体' ? '' : this.formData.productType
        }
      })
    },
    viewSales(scope) {
      var query = {}
      if(this.activeTable == 0) {
        query = {
          saleLocation: scope.column.label == "合计" ? "" : scope.column.label,
          category: scope.row.category,
          categoryType: this.formData.productType,
        }
      }else if(this.activeTable == 1) {
         query = {
          saleLocation: scope.row.typeName,
          category: scope.row.category,
          bigModel: this.formData.bigModel,
          locationType: scope.column.label.includes("上升") ? 'up' : scope.column.label.includes("下降") ? 'down': scope.column.label.includes("不变") ? 'noChange' : "",
          categoryType: this.formData.productType,
          pageFlag: '1'
         }
      }else {
        query = {
          categoryType: scope.row.productType == "整体" ? "" : scope.row.productType, 
          category: scope.row.category,
          bigModel: this.formData.bigModel,
          saleLocation: scope.column.label == "滞销款数量" ? "滞销款" : "",
          locationType: scope.column.label.includes("上升") ? 'up' : scope.column.label.includes("下降") ? 'down': scope.column.label.includes("不变") ? 'noChange' : "",
        }
      }
      this.openSubPage({
        name: "LargeSizeDetails",
        params: query
      })
    },
    flitterData(arr) {
      let spanOneArr = [];
      let concatOne = 0;
      if (arr) {
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            if (item.category === arr[index - 1].category) {
              //第一列需合并相同内容的判断条件
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
      } else {
        spanOneArr = [];
      }

      return spanOneArr;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.activeTable == 1 || this.activeTable == 2) {
        if (columnIndex === 0) {
          const _row = this.flitterData(this.tableData)[rowIndex];
          const _col = _row > 0 && _row ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    yearChange() {
      if(this.formData.year == 2021) {
        this.$set(this.formData,'month',11)
      }else if(this.formData.year == moment().year()) {
        this.$set(this.formData,'month',moment().month()+1)
      }
      this.init()
    },
    changeCategory(row) {
      this.categoryName = row.category
      this.loading2 = true
      this.categoryDialogVisible = true
      let params = [this.yearsMonth,row.category
      ]
      this.$q.newProduct.saleLocationCalcRule({fragment: [...params]}).then((res) => {
        if(res.code == 200) {
          this.categoryTableData = res.data
        }
      }).finally(_=>{
        this.loading2 = false
      })
    },
    init(type) {
      if(this.activeTable != 0) this.getOptions()
      this.tableData = []
      this.exportData = this.formData;
      if (this.activeTable == 0) {
        if (!this.formData.year || !this.formData.month) return;
        this.loading = true;
        this.$q.newProduct
          .categoryList({ data: this.formData })
          .then((res) => {
            if (this.activeTable != 0) return;
            if (res.data.length && res.code == 200) {
              this.tableData = res.data;
            } else {
              this.tableData = [];
            }
          })
          .finally((_) => {
            this.loading = false;
          });
      } else if (this.activeTable == 1) {
        this.loading = true;
        this.$q.newProduct
          .bigModelSalesOverview({ data: this.formData })
          .then((res) => {
            if (this.activeTable != 1) return;
            this.tableData = res.data;
          })
          .finally((_) => {
            this.loading = false;
          });
      } else if (this.activeTable == 2) {
        // if(!this.formData.category || !this.formData.bigModel) return
        this.loading = true;
        this.$q.newProduct
          .proTypeList({ data: this.formData })
          .then((res) => {
            if (this.activeTable != 2) return;
            this.tableData = res.data;
          })
          .finally((_) => {
            this.loading = false;
          });
      } 
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index
      if (index == 1) {
        this.inputData = this.optionData.category;
      } else if (index == 2) {
        this.inputData = this.optionData.bigModel;
      }
    },
    querySkuList(queryString, cb) {
      let data = this.inputData;
      if (!data) {
        cb([]);
        return;
      }
      let results = queryString
        ? data
            .map((v) => v.content)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data
        ? data
            .map((v) => v.content)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    getOptions(type) {
      this.$q.newProduct.dynamicOptions({data:{...this.formData,type: 1}}).then((res) => {
        this.optionData = res.data;
      });;

      
    },
    productCategory(){
      this.$q.newProduct.options({}).then((res) => {
        this.productCategoryData = res.data;
      });
    },
    handleRadioChange() {
      this.formData = {
        year: moment().year(),
        month: moment().month()+1,
        category: "",
        productType: ""
      },
    //   this.tableHeight = this.$refs["wrapper"].offsetHeight - 5;
      this.propList = this.allPropList;
      this.init();
    },
    rowCompare({ row, column }) {
      // console.log(row);
      // console.log(column);
      if (column.label != "品类" && row.productType == "整体" && this.activeTable == 2) {
        return "color: #FF3300";
      }
    },
  },
  mounted() {
    this.productCategory()
    this.handleRadioChange();
  },
};
</script>

<style scoped lang="stylus">
.categoryCilck{
  color: #0BB78E;
  cursor: pointer
}
.categoryRed{
  color: #FF3300;
  cursor: pointer
}
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 20px);
  box-sizing: border-box;
  border-radius: 5px;
}

.header-redio {
  height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

>>> .el-main {
  padding: 5px 8px 0px 16px;
  background: #ffffff;
  border-radius: 5px;
}

.header-text {
  color: #606266;
  padding: 10px 0px 0 0;
}

>>> ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

>>> .el-table__body-wrapper {
  z-index: 3 !important;
  position: relative !important;
}

>>> .el-form-item {
  margin-bottom: 0;
}

>>> .yearSelect .el-input {
  width: 100px !important;
}

>>> .yearSelect {
  width: 100px !important;
}

>>> .el-tabs--border-card>.el-tabs__header {
  border-radius: 8px;
}

>>> .el-tabs__nav-wrap {
  border-radius: 8px;
}

>>> .category .el-form-item__label {
  width: 45px !important;
}

.bg-dc-btn
    background #FF8900
    border none
    float right !important
    margin-right 4px !important
  .bg-dc-btn:hover
    background-color rgba(255,137,0,.8) !important
  .search-btn
    float left
    height 26px
    line-height 26px
    color #fff
    cursor pointer
    font-size 12px
    padding 0 10px
    margin-right 10px
    position relative
    top 8px
    border-radius 4px
  .search-btn:hover
    background rgba(11,183,142,.8)

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
      margin-bottom: 0;
}

//  >>> .el-radio__input.is-checked .el-radio__inner {
//    border-color: #ff8900;
//    background: #ff8900;
//  }

//  >>> .el-radio.is-bordered.is-checked {
//        border-color: #ff8900;
//  }
//  >>> .el-radio__input.is-checked+.el-radio__label {
//     color: #ff8900
//  }
</style>
